"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ChartUp16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0004 1.72502C14.2333 1.91493 14.3684 2.19951 14.3684 2.50001V7.50001H12.3684V5.16448L9.75308 8.15795C9.45085 8.50387 8.95183 8.59941 8.5432 8.38958L7.57758 7.89372L6.40385 10.8672C6.2531 11.2491 5.88425 11.5 5.47369 11.5H3.99605L3.36447 13.5H14V15.5H2.00001C1.68136 15.5 1.38179 15.3482 1.19343 15.0911C1.00507 14.8341 0.950471 14.5027 1.04643 14.1989L2.30958 10.1989C2.44096 9.78285 2.82689 9.50001 3.26317 9.50001H4.79334L6.12248 6.13284C6.22614 5.87025 6.43597 5.6637 6.70016 5.56419C6.96436 5.46468 7.25831 5.48148 7.50944 5.61044L8.76133 6.2533L10.6631 4.07657L8.70121 4.47956L8.2988 2.52046L13.1672 1.52046C13.4616 1.46 13.7675 1.53511 14.0004 1.72502Z", fill: "#131416" }));
}
function ChartUp16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ChartUp16Svg, Object.assign({}, svgProps)));
}
exports.default = ChartUp16;
//# sourceMappingURL=ChartUp16.js.map